import { FC } from 'react'
import { SubsidyFAQContent } from '@/componentsV2/molecules/SubsidyFAQContent'
import { SubsidyFAQInquiryContent } from '@/componentsV2/molecules/SubsidyFAQInquiryContent'
import styles from './index.module.scss'

export const SubsidyFAQGroup: FC = () => {
  return (
    <div className='container'>
      <div className={styles.content}>
        <h2 className={styles.header}>よくある質問</h2>
        <div className={styles.body}>
          <SubsidyFAQContent
            label='補助金とは？'
            text='補助金は、スタートアップや中小企業に提供される財政的な支援です。行政から提供され、新しいビジネスの立ち上げ、研究開発、成長促進など、さまざまな目的に活用できます。補助金を受けることで、資金調達の負担を軽減し、革新的なプロジェクトを推進できるため、スタートアップ企業にとって重要なリソースとなります。'
            isOpen
          />
          <SubsidyFAQContent
            label='「助成金」と「補助金」には何か違いがありますか？'
            text='助成金は対象となる基準を満たすことでほぼ受給することができ、受給しやすいのが特徴です。また管轄は厚生労働省で、雇用の安定などを目的として実施されています。一方、補助金は経済産業省の管轄で、新規事業や起業促進などを目的に実施されています。補助金は助成金と比べ支給金額が高い傾向がありますが、受給の難易度が高くなります。'
          />
          <SubsidyFAQContent
            label='補助金・助成金は返済の必要がありますか？'
            text='返済不要です。しかし、申請前後で申告した事実を偽るなどして不正受給とみなされると、交付した後であっても受給決定取消しとなり返還を求められます。'
          />
          <SubsidyFAQContent
            label='スタートアップでも受給しやすい補助金・助成金はありますか？'
            text='補助金はIT導入補助金や持続化補助金、助成金は人材開発支援助成金や業務改善助成金が使いやすくおすすめです。より詳しい情報が必要な場合はお気軽にお問い合わせください。'
          />
          <SubsidyFAQContent
            label='補助金・助成金の申請支援は可能ですか？'
            text='対応可能です。問い合わせフォームからご相談ください。'
          />
        </div>
        <SubsidyFAQInquiryContent />
      </div>
    </div>
  )
}
